import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { displayWarningToast } from "../../../../store/actions/overflowNotification";
import ImgAskFeedback from "../../../../assets/img/ask-feedback.svg";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import AskWizardWidget from "./widget";
import moment from "moment";

const AskWizard = props => {
  const { wizardCompleted, fromTemplate, onConfirm } = props;
  const navigate = useNavigate();
  const answer = useSelector(state => state.ask.answer);
  const answerDetail = answer.detail;

  const templates = useSelector(state => state.ask.templates);
  const templateDetail = templates.detail;

  const dispatch = useDispatch();

  const [numQuestion, setNumQuestion] = useState(1);
  const [values, setValues] = useState({});
  // const [requiredError, setRequiredError] = useState(null);
  const [tmpDetail, setTmpDetail] = useState({});

  useEffect(() => {
    let tmpV = {};
    let cn = 0;

    if (!fromTemplate) {
      if (answerDetail.items) {
        answerDetail.items.map(item => {
          cn++;
          let itemValue = item.value;
          if (item.format === "date") {
            itemValue = moment(itemValue);
          }
          if (item.value) {
            tmpV["askWizard-item-field_" + cn] = itemValue;
          }
          return null;
        });
        setValues(tmpV);
      }
      setTmpDetail(answerDetail);
    } else {
      if (templateDetail.items) {
        templateDetail.items.map(item => {
          cn++;
          let itemValue = item.value;
          if (item.format === "date") {
            itemValue = moment(itemValue);
          }
          if (item.value) {
            tmpV["askWizard-item-field_" + cn] = itemValue;
          }
          return null;
        });
        setValues(tmpV);
      }
      setTmpDetail(templateDetail);
    }
  }, [answerDetail.items, templateDetail.items]);

  const feedbackOkFirst = useIntl().formatMessage({ id: "ask.feedback.ok1" });
  const feedbackOkSecond = useIntl().formatMessage({ id: "ask.feedback.ok2" });
  const feedbackButton = useIntl().formatMessage({ id: "ask.feedback.button" });

  const onSave = isCompleted => {
    let newItems = [];
    let cn = 0;
    let reqErr;
    tmpDetail.items.map(item => {
      cn++;
      if (!reqErr) {
        if (
          (!values["askWizard-item-field_" + cn] ||
            (item.type === "file" &&
              values["askWizard-item-field_" + cn].length === 0)) &&
          isCompleted &&
          item.required
        ) {
          reqErr = cn;
        } else {
          if ("askWizard-item-field_" + cn in values) {
            if (
              values["askWizard-item-field_" + cn] !== "" &&
              values["askWizard-item-field_" + cn] !== null &&
              values["askWizard-item-field_" + cn] !== [] &&
              values["askWizard-item-field_" + cn] !== undefined
            ) {
              newItems.push({
                ...item,
                value: values["askWizard-item-field_" + cn]
              });
            } else {
              let tmpIt = { ...item };
              delete tmpIt.value;
              newItems.push(tmpIt);
            }
          } else if (item.value) {
            newItems.push({ ...item, value: item.value });
          } else {
            newItems.push({ ...item });
          }
        }
      }
      return null;
    });
    if (!reqErr) {
      onConfirm(
        isCompleted ? "send" : "save",
        !fromTemplate ? tmpDetail.id : null,
        newItems
      );
    } else {
      // setRequiredError(reqErr);
      setNumQuestion(reqErr);
      dispatch(displayWarningToast(`Compilare la domanda n°${reqErr}`, "Attenzione!"));
    }
  };

  const renderTitle = () => {
    if (tmpDetail.items && tmpDetail.items[numQuestion - 1]) {
      return (
        tmpDetail.items[numQuestion - 1].label +
        (tmpDetail.items[numQuestion - 1].required ? " *" : "")
      );
    }
    return undefined;
  };

  const renderHint = () => {
    if (tmpDetail.items && tmpDetail.items[numQuestion - 1]) {
      return tmpDetail.items[numQuestion - 1].hint;
    }
    return undefined;
  };

  if (wizardCompleted) {
    return (
      <div>
        <div className={"askWizard-root"}>
          <div className="askWizard-result-img">
            <img src={ImgAskFeedback} alt="" />
            <div>
              {feedbackOkFirst}{" "}
              <strong>{tmpDetail.title}</strong>{" "}
              {feedbackOkSecond}
            </div>
          </div>
          <div className="askWizard-result-button">
            <Button
              onClick={() => navigate("/ask-list")}
              size="small"
              kind="secondary"
            >
              {feedbackButton}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="askWizard-root">
      <div className="askWizard-header">
        <div className="askWizard-title">{tmpDetail.title}</div>
        <div className="askWizard-subtitle">
          <FormattedMessage id="ask.pages.answer.subtitle" />
        </div>
      </div>
      <div className="askWizard-body">
        <div className="askWizard-summary">
          {tmpDetail.items && tmpDetail.items.length > 1 && numQuestion === 1 && (
            <span>
              <strong><FormattedMessage id="ask.pages.answer.start" /></strong> <FormattedMessage id="ask.pages.answer.compileFirst" />{" "}
              <strong>{tmpDetail.items && tmpDetail.items.length}</strong>
            </span>
          )}
          {tmpDetail.items &&
            numQuestion > 1 &&
            numQuestion < tmpDetail.items.length && (
            <span>
              <strong><FormattedMessage id="ask.pages.answer.good" /></strong> <FormattedMessage id="ask.pages.answer.missingQuestions" />{" "}
              <strong>
                {tmpDetail.items && tmpDetail.items.length - numQuestion + 1}
              </strong>{" "}
              <FormattedMessage id="ask.pages.answer.questions" />
            </span>
          )}
          {tmpDetail.items &&
            numQuestion === tmpDetail.items.length &&
            tmpDetail.items.length > 1 && (
            <span>
              <strong><FormattedMessage id="ask.pages.answer.good2" />,</strong> <FormattedMessage id="ask.pages.answer.youAre" /><strong><FormattedMessage id="ask.pages.answer.last" /></strong>{" "}
              <FormattedMessage id="ask.pages.answer.question" />
            </span>
          )}
        </div>
        <div className="askWizard-question-container">
          <div className="askWizard-prev">
            <div
              onClick={() => setNumQuestion(numQuestion - 1)}
              style={{ display: numQuestion > 1 ? "" : "none" }}
            >
              <FontAwesomeIcon icon={["far", "arrow-left"]} />
            </div>
          </div>
          <div className="askWizard-question">
            <div className="askWizard-question-title">
              {tmpDetail.items &&
                tmpDetail.items[numQuestion - 1].type !== "file" &&
                renderTitle()}
            </div>
            <div className="askWizard-question-widget">
              <AskWizardWidget
                tmpDetail={tmpDetail}
                numQuestion={numQuestion}
                values={values}
                setValues={val => setValues(val)}
              />
            </div>
            <div className="askWizard-question-hint">{renderHint()}</div>
          </div>
          <div className="askWizard-next">
            <div
              onClick={() => setNumQuestion(numQuestion + 1)}
              style={{
                display:
                  tmpDetail.items && tmpDetail.items.length > numQuestion
                    ? ""
                    : "none"
              }}
            >
              <FontAwesomeIcon icon={["far", "arrow-right"]} />
            </div>
          </div>
        </div>
      </div>
      <div className="askWizard-footer">
        {!fromTemplate && (
          <Button
            onClick={() => onSave(false)}
            kind="primary"
            style={{ width: 140 }}
          >
            <FormattedMessage id="ask.saveDraft" />
          </Button>
        )}
        <Button
          onClick={() => onSave(true)}
          kind="primary"
          style={{
            display:
              tmpDetail.items && tmpDetail.items.length === numQuestion
                ? ""
                : "none",
            width: 140
          }}
        >
          <FormattedMessage id="generic.send" />
        </Button>
      </div>
    </div>
  );
};

export default AskWizard;
